<script setup lang="ts">
// One consent row: label, description, switch. A native checkbox (sr-only
// peer) keeps keyboard and screen readers working; track and knob are drawn
// from its state.
defineProps<{ label: string; description: string; locked?: boolean }>();

const enabled = defineModel<boolean>({ required: true });
</script>

<template>
  <label class="flex items-start justify-between gap-6" :class="locked ? 'cursor-not-allowed' : 'cursor-pointer'">
    <span class="flex flex-col gap-0.5">
      <span class="text-[15px] font-semibold text-text-base">{{ label }}</span>
      <span class="text-[13px] leading-5 text-text-dim">{{ description }}</span>
    </span>
    <span class="relative mt-0.5 shrink-0" :class="locked ? 'opacity-60' : ''">
      <input v-model="enabled" type="checkbox" :disabled="locked" class="peer sr-only" />
      <span class="block h-6 w-11 rounded-full bg-bg-mute transition-colors peer-checked:bg-accent peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-accent" aria-hidden="true" />
      <span class="absolute left-0.5 top-0.5 size-5 rounded-full bg-text-base transition-transform motion-reduce:transition-none peer-checked:translate-x-5 peer-checked:bg-text-inv" aria-hidden="true" />
    </span>
  </label>
</template>
